// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { PROVIDER_ELAVON } from '../../utils/elavonPayments';

const formatCardBrand = (brand) => {
  if (!brand) return 'Card';
  return brand.charAt(0).toUpperCase() + brand.slice(1);
};

const PaymentMethodCard = ({
  paymentMethod, editPaymentMethod, deletePaymentMethod, makePrimary, isUpdating,
}) => {
  const card = paymentMethod.card || {};
  const isElavon = paymentMethod.provider === PROVIDER_ELAVON;
  const isBank = paymentMethod.type === 'bank' || paymentMethod.type === 'us_bank_account';

  return (
    <div className="bank-card">
      <h3 className="bank-card-name">
        {isBank ? formatCardBrand(card.brand) : formatCardBrand(card.brand)}
        {!isBank && ' ···· '}
        {!isBank && card.last4}
        {isElavon && (
          <span className="bank-card-provider"> (Converge)</span>
        )}
      </h3>
      <p className="bank-card-status">
        {isBank
          ? `Account ending in ${card.last4 || '—'}`
          : (
            <>
              Expires
              {' '}
              {card.exp_month}
              /
              {card.exp_year}
            </>
          )}
      </p>
      {paymentMethod.isPrimary && <p className="bank-card-status">Primary</p>}
      <div className="bank-card-actions">
        {!paymentMethod.isPrimary && (
          <button
            type="button"
            className="bank-card-action"
            disabled={isUpdating}
            onClick={() => makePrimary(paymentMethod)}
          >
            Make Primary
          </button>
        )}
        <button
          type="button"
          className="bank-card-action"
          disabled={isUpdating}
          onClick={() => deletePaymentMethod(paymentMethod)}
        >
          Remove
        </button>
        {!isElavon && !isBank && (
          <button
            type="button"
            className="bank-card-action"
            disabled={isUpdating}
            onClick={() => editPaymentMethod(paymentMethod)}
          >
            Edit
          </button>
        )}
      </div>
    </div>
  );
};

export default PaymentMethodCard;
